// Framework
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// Providers
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs';
import { DataService } from './data.service';

@Injectable()

export class AuthService {
    isLoggedIn: boolean = false;
    isEmailVerified: boolean = false;
    $authState: Observable<firebase.User>;

    constructor (
        private firebaseAuth: AngularFireAuth,
        private dataSvc: DataService,
        private router: Router
    ) {
        this.$authState = firebaseAuth.authState;
    }

    // Return the currentUser from firebase.auth()
    currentUser(): firebase.User {
        // let email = (firebase.auth().currentUser ? firebase.auth().currentUser.email : "");
        // this.dataSvc.childPilotUsers.forEach((cpUser) => {
        //     if(cpUser.email == email) {
        //         this.dataSvc.loggedInUser = cpUser;
        //     }
        // });
        //this.dataSvc.setUID(firebase.auth().currentUser.uid);

        return firebase.auth().currentUser;
    }

    // Login using firebase email auth.
    loginEmail(email: string, password: string): Promise<firebase.auth.UserCredential> {
        return this.firebaseAuth.auth.signInWithEmailAndPassword(email, password)
            .then((user) => {
                return user;
             })
            .catch((err) => {
                console.log(err);
                return Promise.reject(err);
            });
    }

    signUp(email: string, password: string): Promise<firebase.auth.UserCredential> {
        return this.firebaseAuth.auth.createUserWithEmailAndPassword(email, password)
            .then((user) => {
                return user;
             })
            .catch((err) => {
                console.log(err);
                return Promise.reject(err);
            });
    }

    forgotpassword(email: string, password: string): Promise<any> {
        return this.firebaseAuth.auth.sendPasswordResetEmail(email)
            .then((user: any) => {
                return user;
             })
            .catch((err) => {
                console.log(err);
                return Promise.reject(err);
            });
    }

    // Logout using firebase.
    logout(): Promise<any> {
        return this.firebaseAuth.auth.signOut()
            .then((value) => {
                this.router.navigate(['/login'], { queryParamsHandling: 'preserve' });
                return value;
            })
            .catch((err) => {
                console.log(err);
                return err;
            });
    }
}